// import "@babel/polyfill"
import Vue from 'vue'
import global_mixin from '../global_mixins.js'
import LazyBackground from '../../components/LazyBackground.vue'
import '../../css/commercial/index.css'
var _ = require('lodash')
import gql from 'graphql-tag'
import VueGallery from '../../components/Gallery.vue'
/*var lightGallery = require('lightgallery.js')*/
import 'lightgallery.js'
import 'lightgallery.js/dist/css/lightgallery.css'
import 'lg-video.js'
import VueTinySlider from 'vue-tiny-slider'
import { tns } from "tiny-slider/src/tiny-slider"
import CommercialContactForm from '../../components/CommercialContactForm.vue'
import LogoCarousel from '../../components/LogoCarousel.vue'
Vue.component('lazy-background', LazyBackground)

const app = new Vue({
  el: '#app',
  components: {
    'gallery': VueGallery,
    'tiny-slider': VueTinySlider,
    'commercial-contact-form': CommercialContactForm,
    'logo-carousel': LogoCarousel
  },
  mixins: [global_mixin],
  data() {
    return {
      currentSlide: 0,
      slides: [],
      seriesData: {},
      currentSeriesPolaroids: [],
      initialDataLoaded: false,
      currentSeriesID: 0,
      slideDirection: 'right',
      showGallery: false,
      isTransitioningSeries: false,
      polaroidLeft: 0,
      polaroidRight: 4,
      polaroids: [],
      currentVideo: "",
      polaroidDisplayLimit: 4,
      lightboxIndex: null,
      lightboxKey: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
      mainSlider: null
    }
  },
  mounted() {
    const currentCommercialScenes = JSON.parse(JSON.parse(document.getElementById('commercial_scenes').textContent))
    _.map(currentCommercialScenes.allCommercialSpaces.edges, (o) => {
      let scenes = _.map(o.node.scenes.edges, (a) => {
        if (a.node.featuredImage) {
          this.slides.push({
          image: a.node.sliderImage,
          thumbnail: a.node.thumbnail,
          category: o.node.category,
          brandName: a.node.brandName,
          colorsInImage: a.node.colorsInImage,
          seriesInImage: JSON.parse(JSON.parse(a.node.seriesInImage)),
          shapesInImage: a.node.shapesInImage,
          seoDescription: a.node.seoDescription
        })
        }
      })
      return scenes
    })
    this.$nextTick(async function() {
                await this.updateMainSlider()
              });
    
  },
  methods: {
    setSlideDirectionLeft() {
      this.slideDirection = 'left'
      setTimeout(() => {
        this.slideDirection = 'right'
      }, 2500)
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async updateMainSlider() {
      this.mainSlider = tns({
        container: '.mainSlider',
        items: 1,
        autoplay: false,
        controls: true,
        nav: false,
        autoplayButtonOutput: false,
        edgePadding: 0,
        gutter: 15,
        nextButton: '#mainNext',
        prevButton: '#mainPrev',
        responsive: {
          321: {
            edgePadding: 0,
            mouseDrag: true,
          },
          768: {
            mouseDrag: false,
          },
          992: {
            edgePadding: 200,
          },
          1400: {
            edgePadding: 300,
          },
          1600: {
            edgePadding: 400,
          }
        }
      });
      this.mainSlider.events.on('indexChanged', (item) => {

        this.currentSlide = item.displayIndex + 1
        for (let i = 1; i < item.slideItems.length; i++) {

          let slide = item.slideItems[i]
          if (i == this.currentSlide) {
            item.slideItems[i].children[0].classList.add("opacity")
            item.slideItems[i].children[1].classList.add("opacity")
          }
          else {
            item.slideItems[i].children[0].classList.remove("opacity")
            item.slideItems[i].children[1].classList.remove("opacity")
          }
        }

      });
      document.getElementsByClassName('slider-product-info')[2].classList.add("opacity")

    },
    getInfo: function(event) {
      let sliderInfo = this.$refs.tinySlider.slider.getInfo();
    }
  },
  computed: {
    getIndex() {
      let index = 0
      if (this.mainSlider) {
        console.log("running computed")
        index = this.mainSlider.getInfo().index;
      }
      return index
    }

  },

});



// WEBPACK FOOTER //
// ./core/vue/js/commercial/index.js